// import {AxiosInstance} from "axios";

// /**
//  * NOTE: Currently we're not using redux in this project.
//  * The type of this will be changed to the proper
//  * redux store type once we start using redux.
//  */
// // import type {StoreType} from "@store/index";
// type StoreType = any;

// /**
//  * Mapping all the responseInterceptors defined as closures inside this function
//  * to the axios-instance apiServer.
//  *
//  * Defined responseInterceptor closures needs to be registered to the constant object
//  * axiosResponseInterceptors in order to get mapped.
//  *
//  * @param store
//  * @param apiServer
//  */
// function AxiosResponseInterceptors(
// 	store: StoreType | null,
// 	apiServer: AxiosInstance,
// ): void {
// 	// TODO: add responseNetworkFailureInterceptor

// 	/**
// 	 * All response-interceptors should be registered here.
// 	 *
// 	 * eg: {
// 	 *     responseAuthorizationTokenExpireInterceptor: responseAuthorizationTokenExpireInterceptor
// 	 * }
// 	 */
// 	const axiosResponseInterceptors = {};

// 	/**
// 	 * Extracting and mapping each responseInterceptor defined inside
// 	 * AxiosInterceptors.responseInterceptors with the axios-instance
// 	 * apiServer.
// 	 */
// 	Object.values(axiosResponseInterceptors).forEach(
// 		(responseInterceptor: any) => {
// 			apiServer.interceptors.response.use(
// 				responseInterceptor.onFulfilled,
// 				responseInterceptor.onRejected,
// 			);
// 		},
// 	);
// }

// export default AxiosResponseInterceptors;











import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import swal from 'sweetalert';

type StoreType = any;

const SESSION_EXPIRED_FLAG = 'isSessionExpiredPromptShown';
const SESSION_EXPIRED_MESSAGE = 'Session expired! Please log in again to continue!';
const LOGIN_ROUTE = '/signin';

type ErrorPayload =
  | string
  | {
      message?: string;
      error?: string;
      detail?: string;
    }
  | null
  | undefined;

const getTokenExpiryMessage = (payload: ErrorPayload): string => {
  if (!payload) return '';

  if (typeof payload === 'string') {
    return payload.toLowerCase();
  }

  return [payload.message, payload.error, payload.detail]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
};

const isExpiredTokenError = (error: AxiosError): boolean => {
  if (error.response?.status !== 401) {
    return false;
  }

  const token =
    typeof window !== 'undefined' ? localStorage.getItem('userToken') : null;
  if (!token) {
    return false;
  }

  const errorMessage = getTokenExpiryMessage(error.response?.data as ErrorPayload);
  const expirySignals = [
    'token expired',
    'jwt expired',
    'session expired',
    'expired token',
    'invalid token',
    'token is invalid',
    'authorization token expired',
  ];

  return expirySignals.some((signal) => errorMessage.includes(signal)) || !errorMessage;
};

const clearAuthStateAndRedirect = (): void => {
  localStorage.clear();
  sessionStorage.clear();
  window.location.replace(LOGIN_ROUTE);
};

export const promptLoginOnExpiredToken = (error: AxiosError): Promise<never> => {
  if (typeof window !== 'undefined' && isExpiredTokenError(error)) {
    const isPromptShown = sessionStorage.getItem(SESSION_EXPIRED_FLAG);

    if (!isPromptShown) {
      sessionStorage.setItem(SESSION_EXPIRED_FLAG, 'true');

      try {
        void swal(SESSION_EXPIRED_MESSAGE).then(() => {
          clearAuthStateAndRedirect();
        });
      } catch {
        alert(SESSION_EXPIRED_MESSAGE);
        clearAuthStateAndRedirect();
      }
    }
  }

  return Promise.reject(error);
};

/**
 * Interceptor to handle token expiration (Client-side only).
 */
const responseAuthorizationTokenExpireInterceptor = {
    onFulfilled: (response: AxiosResponse) => {
        return response;
    },
    onRejected: (error: AxiosError) => promptLoginOnExpiredToken(error),
};

/**
 * Function to register response interceptors.
 */
function AxiosResponseInterceptors(
    store: StoreType | null,
    apiServer: AxiosInstance
): void {
    if (typeof window !== 'undefined') {
        apiServer.interceptors.response.use(
            responseAuthorizationTokenExpireInterceptor.onFulfilled,
            responseAuthorizationTokenExpireInterceptor.onRejected
        );
    }
}

export default AxiosResponseInterceptors;
